/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import Loading from '../../components/loading/loading.component';

class WaitingModal extends React.Component {
  click(e) {
    e && e.click(); //simulated click to hide the dropdown menu
  }

  render() {
    return (
      <div id="waiting-modal">
        <div id="waiting-spinner" ref={this.click}>
          <Loading />
        </div>
      </div>
    );
  }
}

export default WaitingModal;
